// REAL. Fires POST /analyze with the parsed project + chosen methodology
// + character pick. Renders an honest "thinking" beat while the LLM call
// runs (~30-90s per script). On success, navigate to /room with
// `replace: true` — the welcome arc is consumed once; back-button from
// /room should not re-watch the analyzer load.
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { postAnalyze } from "../api/client";
import { useArc } from "../state/arc";

export default function BuildingRoom() {
  const navigate = useNavigate();
  const { state, update } = useArc();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (
      !state.parsedProject ||
      !state.selectedCharacter ||
      !state.methodologyId
    ) {
      navigate("/upload", { replace: true });
      return;
    }
    let cancelled = false;
    postAnalyze({
      project: state.parsedProject,
      methodology_id: state.methodologyId,
      selected_characters: [state.selectedCharacter],
    })
      .then((analysis) => {
        if (cancelled) return;
        update({ analysis });
        navigate("/room", { replace: true });
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e?.message ?? "Analyzer failed.");
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section>
      <h2>Building your rehearsal room…</h2>
      <p>
        {/* Show the actor their tradition, never the raw methodology id
            (recognition-not-classification: the actor sees register, never
            schema). Falls back gracefully if the quiz result isn't present. */}
        Reading {state.parsedProject?.script_name ?? "your script"} through{" "}
        {state.quizResult?.lineage.tradition_name ?? "the way you work"} for{" "}
        {state.selectedCharacter ?? "your character"}.
      </p>
      <p className="muted">
        This takes about a minute — the analyzer is reading the full
        scene end-to-end.
      </p>
      {error && (
        <>
          <p style={{ color: "#e08383" }}>{error}</p>
          <button onClick={() => navigate("/upload")}>← Start over</button>
        </>
      )}
    </section>
  );
}
